type HelpDrawerEventPayload = {
  drawerId: string;
  action: 'open' | 'close';
  openedAt?: string | null;
  closedAt?: string | null;
  durationMs?: number | null;
};

const postHelpDrawerEvent = (payload: HelpDrawerEventPayload) => {
  try {
    const body = JSON.stringify(payload);
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon('/api/analytics/help-drawer', blob);
      return;
    }

    void fetch('/api/analytics/help-drawer', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
      keepalive: true,
    });
  } catch (error) {
    console.warn('[analytics] failed to enqueue help drawer event', error);
  }
};

export const trackHelpDrawerEvent = (payload: HelpDrawerEventPayload) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (typeof window.analytics?.track === 'function') {
      window.analytics.track('Help Drawer Interaction', {
        drawerId: payload.drawerId,
        action: payload.action,
        openedAt: payload.openedAt ?? null,
        closedAt: payload.closedAt ?? null,
        durationMs: payload.durationMs ?? null,
      });
    }
  } catch (error) {
    console.warn('[analytics] failed to emit help drawer event to Segment', error);
  }

  postHelpDrawerEvent(payload);
};
